import type { VendorMetadataExtractor } from './types'
import { extractEmbeddedGps } from './embedded-gps'

export const blackvueExtractor: VendorMetadataExtractor = {
  vendorId: 'blackvue',
  vendorLabel: 'BlackVue',
  supportsDirectoryBrowse: false,

  // BlackVue writes ASCII NMEA in a `gps ` box; read by the shared embedded GPS scanner.
  extractFromFiles: extractEmbeddedGps
}
